import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import FindingDataGrid from '../FindingDataGrid/FindingDataGrid';
import FindingList from '../FindingList/FindingList';
import type { Filter } from '#/common/components/DataGrid';

interface FindingsProps {
  omitColumns?: string[];
  hideNewAction?: boolean;
  permanentFilters?: Filter[];
}

const Findings: React.FC<FindingsProps> = ({ omitColumns, hideNewAction, permanentFilters }) => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <FindingDataGrid
          omitColumns={omitColumns}
          hideNewAction={hideNewAction}
          permanentFilters={permanentFilters}
        />
      </If>
      <If condition={!isDesktop}>
        <FindingList hideNewAction={hideNewAction} permanentFilters={permanentFilters} />
      </If>
    </>
  );
};

export default React.memo(Findings);
